import {Constant} from '../../../util/constant';
import {MultiSelect} from '../../MultiSelect';
import {Injectable} from '@angular/core';
@Injectable({
  providedIn: 'root'
})
export class TestingSpecialMultiSelects extends MultiSelect {


  objectMultiSelects = {
    ['testType']: {
      name: Constant.TESTING_SPECIAL_LOV_TYPE,
      dbField: 'testType',
      label: 'Test Type',
      list: [],
      currentSelected: [],
      isRequired: true,
      error: false


    }
  };

  getResponse($event): any {
    return super.getResponse($event);
  }

  getResponseObjects($event): any {
    return super.getResponseObjects($event);
  }

}
